var scoreIsEmpty=function(e){return!e||0===Object.keys(e).length};export{scoreIsEmpty};